import { toast } from 'react-toastify'
import moment from 'moment'
import { createAxiosInstance, uploadMaxSize } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'
import history from '../utils/history'
import { displayMessages, getParameterByName, uploadFiles } from './common'

export function initReducer() {
	return (dispatch) => {
		dispatch({ type: types.REINICIAR_SOLICITUD_BIENES_INVESTIGACION })
	}
}

export function updateInputs(path, value) {
	return (dispatch) => {
		dispatch({ type: types.MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION, payload: { path, value } });
	}
}

export function addSolicitudBienesItem() {
	return {
		type: types.ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION
	}
}

export function editSolicitudBienesItem(index, data) {
	return {
		type: types.MODIFICAR_ITEM_SOLICITUD_BIENES_INVESTIGACION,
		index,
		data
	}
}

export function addCencoSolicitudBienesItem() {
	return (dispatch) => {
		dispatch({ type: types.ADICIONAR_NUEVO_CENCO_SOLICITUD_BIENES_INVESTIGACION })
	}
}

export function removeCencosSolicitudBienesItem() {
	return (dispatch) => {
		dispatch({ type: types.ELIMINAR_CENCOS_SOLICITUD_BIENES_INVESTIGACION_ITEM })
	}
}

export function removeSolicitudBienesItem() {
	return (dispatch) => {
		dispatch({ type: types.ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION })
	}
}

export function toggleSelectAllSolicitudBienesItems(checked) {
	return (dispatch) => {
		dispatch({ type: types.CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_BIENES_INVESTIGACION, payload: checked })
	}
}

export function toggleSelectAllSolicitudBienesCencos(checked) {
	return (dispatch) => {
		dispatch({ type: types.CONMUTAR_SELECCION_TODOS_CENCOS_SOLICITUD_BIENES_INVESTIGACION, payload: checked })
	}
}

export function addSolicitudServicioBIFile() {
	return (dispatch, getState) => {
		const data = getState().common.getIn(['modalAddFile', 'data'])
		const fn1 = (d) => d({ type: types.ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_BIENES_INVESTIGACION, payload: data })
		fn1(dispatch)
	}
}


export function removeSolicitudServicioBIFiles() {
	return (dispatch) => {
		dispatch({ type: types.ELIMINAR_ARCHIVOS_SOLICITUD_BIENES_INVESTIGACION })
	}
}


export function createSolicitudBienes() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_GUARDAR_SOLICITUD_BIENES_INVESTIGACION, payload: true })
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_GUARDAR_SOLICITUD_BIENES_INVESTIGACION, payload: false })
		const fn2 = (d) => d(initReducer())

		fn0(dispatch)
		const data = getState().creacionsolicitudBI

		const errors = validarSolicitud(data)

		const files = data.get('adjuntos')

		if (errors.length) {
			return errors.forEach(element => {
				toast.warning(element, {bodyClassName: 'toastify-content toastify-warning'})
			});
		} else {
			axios.post(`${API_URL}/solicitudes/bienes-investigacion`, data)
				.then(res => {

					const fn3 = () => history.push(window.FOLDER + '/');
					const fn4 = () => toast.success('La solicitud ha sido guardada exitosamente', { bodyClassName: 'toastify-content toastify-success' })
					dispatch(uploadFiles(`/files/${res.data.solicitud.id}`, files, [fn1, fn2, fn3, fn4]))

				})
				.catch(err => {
					displayMessages(dispatch, err)
					fn1(dispatch)
				})
		}
	}
}



export function enviarComentario() {
	return (dispatch, getState) => {
		const guid = getState().creacionsolicitudBI.getIn(['comentario', 'guid'])
		const comentario = getState().creacionsolicitudBI.getIn(['comentario', 'texto'])
		const usuario = getState().common.get('user')
		const fn1 = (d) => d({ type: types.ENVIAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION, payload: {comentario, guid , usuario} })
		fn1(dispatch)
	}
}

export function editarComentario(guid) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION, payload: {guid} })
		fn1(dispatch)
	}
}

export function eliminarComentario(guid) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.ELIMINAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION, payload: { guid } })
		fn1(dispatch)
	}
}


function validarSolicitud(data) {
    const errors = []
    //Foreach bien, validar que la descripcion no sea repetida
    const descripciones = {}
    data.get('bienes').forEach((item, index) => {
        const desc = item.get('descripcion').trim().toLowerCase()
        if (descripciones[desc]) {
            errors.push(`Item ${index + 1}: La descripción "${item.get('descripcion')}" está repetida en el ítem ${descripciones[desc]}`)
        } else {
            descripciones[desc] = index + 1
        }
    })


    data.get("bienes").forEach((item, index) => {
        if (!item.get("unidad")) {
            errors.push(
                `Item ${index + 1}: La unidad en "${item.get("descripcion")}" es requerida`,
            );
        }
    });


    // validar si hay un bien con cantidad cero
	const index = data.get('bienes').findIndex(item => Number(item.get('cantidad_requerida')) === 0)
	if (index >= 0){
		errors.push(`Item ${index+1}: ${data.getIn(['bienes', index, 'descripcion'])} debe ser mayor a cero`)
	}

	// validar si porcentaje de distribucion de cencos es igual a 100
	const porcentaje = data.get('cencos').reduce((a ,b) => { a += Number(b.get('porcentaje')); return a }, 0)
	if (porcentaje !== 100) {
		errors.push(`El porcentaje total de distribución de los cencos es diferente de 100`)
	}
	if (data.get('fecha_requerido') && moment().subtract('days', 1).isAfter(data.get('fecha_requerido'))){
		errors.push('La fecha de entrega no debe ser inferior a la de hoy')
	}
	if (data.get('cencos').filter(x => x.get('cenco') === null).count() > 0){
		errors.push('La creación de bienes requiere que todos los centros de costos estén definidos')
	}

	if (data.get('cencos').filter(x => x.get('porcentaje') < 1).count() > 0) errors.push('El porcentaje en los cencos debe ser mayor a 0')


	if (data.get('adjuntos').count() > 0) {

		const size = data.get('adjuntos').reduce((a, b) => { a += b.get('file').size; return a }, 0)
		if (size > uploadMaxSize.value) errors.push(`La capacidad máxima para subir archivos es de de ${uploadMaxSize.unidad}`)

		if (data.get('adjuntos').filter(x => !x.get('clasificacion')).count() > 0) errors.push('Todos los archivos deben tener una clasificación')

	}

	return errors
}



// WEBPACK FOOTER //
// ./src/actions/creacionSolicitudbi.js